import { isPastDate } from '.'
import { PSApplication } from '../components/app/PSApplication'
import { Booking } from '../models/Booking'
import { Item } from '../models/Item'
import { User } from '../models/User'
import { currencyFormat } from './numbers'

export const isForVendor = (record?: any, owner?: User) =>
    !record?.vendor ? owner?.id === record?.owner : owner?.id === record.vendor

type LateInfo = {
    isCancellableClass: boolean
    isCancellableSeries: boolean
    isLate: boolean
    forVendor: boolean
    forClass: boolean
}

export const bookingLateInfo = (
    record: Booking,
    item: Item | undefined,
    user: User,
    vendor: User
): LateInfo => {
    const forVendor = PSApplication.owner().id === record.owner?.id
    const forClass = (!!record.item && record.type === 'class') || (!!record.id && !!record.lesson)
    const isCancellableClass = forClass && (forVendor || item?.classType === 'dropin')
    const isCancellableSeries = forVendor && !!record.schedule && !!record.schedule.createdDate
    const isLate =
        !!vendor.cancellationRate &&
        isPastDate(record.date?.toDate() || '', vendor.cancellationDuration ?? 0) &&
        record.status === 'confirmed'

    return {
        isCancellableClass,
        isCancellableSeries,
        isLate,
        forClass,
        forVendor,
    }
}

export const cancellationFeeString = (vendor: User) =>
    vendor.cancellationRateType === 'percent'
        ? `${vendor.cancellationRate}%`
        : `${currencyFormat(vendor.cancellationRate)}`

export const subscriptionCancellationFeeString = (vendor: User) =>
    vendor.subscriptionCancellationRateType === 'percent'
        ? `${vendor.subscriptionCancellationRate}%`
        : `${currencyFormat(vendor.subscriptionCancellationRate)}`
